// extracted by mini-css-extract-plugin
export default {"sidebar_wrapper":"SidebarLayoutPage_sidebar_wrapper__GgIHZ","outlet_wrapper":"SidebarLayoutPage_outlet_wrapper__SvVxR"};